import React from 'react';

export default function CircleX(props) {
  return (
    <svg width={56} height={56} viewBox="0 0 56 56" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g transform="translate(-1326 -16854)">
        <g>
          <g>
            <use xlinkHref="#circle-x-path0_fill" transform="translate(1338 16866)" fill="#111111" fillOpacity="0.1" />
            <mask id="circle-x-mask0_outline_out">
              <rect fill="white" x={-2} y={-2} width={36} height={36} transform="translate(1338 16866)" />
              <use xlinkHref="#circle-x-path0_fill" fill="black" transform="translate(1338 16866)" />
            </mask>
            <g mask="url(#circle-x-mask0_outline_out)">
              <use xlinkHref="#circle-x-path1_stroke_2x" transform="translate(1338 16866)" fill="#FFFFFF" fillOpacity="0.95" />
            </g>
          </g>
          <g>
            <use xlinkHref="#circle-x-path0_fill" transform="translate(1338 16866)" fill="#111111" fillOpacity="0.1" />
          </g>
          <g>
            <use xlinkHref="#circle-x-path2_fill" transform="matrix(0.707107 0.707107 -0.707107 0.707107 1354 16873.5)" fill="#FFFFFF" />
          </g>
        </g>
      </g>
      <defs>
        <path id="circle-x-path0_fill" fillRule="evenodd" d="M 16 32C 24.8366 32 32 24.8366 32 16C 32 7.16344 24.8366 0 16 0C 7.16344 0 0 7.16344 0 16C 0 24.8366 7.16344 32 16 32Z" />
        <path id="circle-x-path1_stroke_2x" d="M 16 34C 25.9411 34 34 25.9411 34 16L 30 16C 30 23.732 23.732 30 16 30L 16 34ZM 34 16C 34 6.05887 25.9411 -2 16 -2L 16 2C 23.732 2 30 8.26801 30 16L 34 16ZM 16 -2C 6.05887 -2 -2 6.05887 -2 16L 2 16C 2 8.26801 8.26801 2 16 2L 16 -2ZM -2 16C -2 25.9411 6.05887 34 16 34L 16 30C 8.26801 30 2 23.732 2 16L -2 16Z" />
        <path id="circle-x-path2_fill" fillRule="evenodd" d="M 6.49862 0L 5.49864 8.63167e-05L 5.49769 5.50045L 8.63167e-05 5.5014L 0 6.50138L 5.4976 6.50043L 5.49803 11.9994L 6.49931 12.0008L 6.49931 6.50138L 11.9993 6.50077L 11.9994 5.50079L 6.49931 5.50148L 6.49862 0Z" />
      </defs>
    </svg>
  );
}
